'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getLang from 'I18n/utils/getLang';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIFlex from 'UIComponents/layout/UIFlex';
import LearningPageHeader from './LearningPageHeader';
import TrackBody from './TrackBody';
import { fetchTrackByIdIfNeeded, getRecommendedTracks } from '../../actions/TrackActions';
import { trackIsLoading, getTrack, getIsLastLessonInTrack } from '../../selectors/trackSelectors';
import TrackNavigatorContainer from '../Navigator/TrackNavigator/TrackNavigatorContainer';
import LearningPageSidebar from './LearningPageSidebar';
import LearningPageMainSection from './LearningPageMainSection';
import styled from 'styled-components';
import { getSelectedLanguageFiltersFromRoute } from '../../selectors/routeSelectors';
import useLanguagesSwitch from '../../hooks/useLanguageSwitch';
import { getContentById } from '../../selectors/contentSelectors';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
const StickyDiv = styled.div.withConfig({
  displayName: "TrackPageRouter__StickyDiv",
  componentId: "sc-1okt6v-0"
})(["position:sticky;top:49px;z-index:3;"]);

const TrackPageRouter = ({
  content,
  isLastLessonInTrack,
  isLoading,
  fetchTrack,
  fetchRecommendedTracks,
  language,
  match,
  track
}) => {
  const {
    params: {
      trackId,
      lessonId,
      contentId
    }
  } = match;
  const langLoaded = useLanguagesSwitch({
    language
  });
  const ContentTitle = content && content.get('name');
  useEffect(() => {
    if (isLastLessonInTrack) {
      fetchRecommendedTracks(trackId);
    }
  }, [fetchRecommendedTracks, isLastLessonInTrack, trackId]);
  useEffect(() => {
    fetchTrack(trackId, language);
  }, [trackId, fetchTrack, language]);
  const isLoadingAndNoTrackData = !langLoaded || isLoading && (!track || track.get('language', '').toUpperCase() !== language);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StickyDiv, {
      children: !isLoadingAndNoTrackData && /*#__PURE__*/_jsx(LearningPageHeader, {
        ContentName: content && content.get('quizType') ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.lessonNavigator.quiz"
        }) : ContentTitle,
        defaultBackLink: {
          pathname: '/'
        },
        language: language,
        trackId: trackId
      })
    }), isLoadingAndNoTrackData ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      minHeight: 400
    }) : /*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx(LearningPageSidebar, {
        id: "sidebarNavigator",
        withSubNav: 1,
        children: /*#__PURE__*/_jsx(TrackNavigatorContainer, {})
      }), /*#__PURE__*/_jsx(LearningPageMainSection, {
        children: /*#__PURE__*/_jsx(TrackBody, {
          contentId: contentId,
          lessonId: lessonId,
          trackId: trackId
        })
      })]
    })]
  });
};

TrackPageRouter.propTypes = {
  content: PropTypes.object,
  fetchRecommendedTracks: PropTypes.func,
  fetchTrack: PropTypes.func,
  isLastLessonInTrack: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  language: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      contentId: PropTypes.string,
      lessonId: PropTypes.string,
      trackId: PropTypes.string
    }).isRequired
  }).isRequired,
  track: ImmutablePropTypes.map
};

const mapStateToProps = () => {
  return (state, ownProps) => {
    const {
      match: {
        params: {
          trackId,
          lessonId,
          contentId
        }
      }
    } = ownProps;
    const selectedTrack = getTrack(state, {
      trackId
    });
    const content = getContentById(state, contentId);
    const selectedTrackLanguage = selectedTrack ? selectedTrack.get('language') || getLang() : getLang();
    return {
      content,
      isLastLessonInTrack: getIsLastLessonInTrack(state, {
        lessonId,
        trackId
      }),
      isLoading: trackIsLoading(state, {
        trackId
      }),
      track: selectedTrack,
      language: getSelectedLanguageFiltersFromRoute(state, ownProps).first() || selectedTrackLanguage
    };
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    fetchTrack: fetchTrackByIdIfNeeded,
    fetchRecommendedTracks: getRecommendedTracks
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackPageRouter);